import { useCallback } from 'react';
import { PROFILE_PAGE_TYPES } from '@common/types';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { ENABLE_AGENCY_PROFILE_CONTACT_FORM } from '@utils/constants';
import { getWixLoginUrl } from '@utils/urlUtils';
import { useExperiments, useTranslation } from '@wix/fe-essentials-standalone';
import _ from 'lodash';

const useProfileContactButton = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isAgencyContactFormEnabled = experiments.enabled(
    ENABLE_AGENCY_PROFILE_CONTACT_FORM,
  );

  const {
    i18n: { language },
  } = useTranslation();
  const {
    partnerProfile,
    isMyProfile,
    enabled,
    isRenderedInModal,
    profilePageType,
  } = useProfileContext();
  const { userDetails } = useProfileContext();

  // TODO: remove when usePublicPartnerProfiles spec is merged
  const shouldRenderContactButtonWithoutPageType =
    !isMyProfile && enabled && !isRenderedInModal;

  const havePageType = Boolean(profilePageType);

  const isAgency = profilePageType === PROFILE_PAGE_TYPES.agency;

  const shouldUseMailToButton = isAgency && !isAgencyContactFormEnabled;

  const shouldUseAgencyContactForm = isAgency && isAgencyContactFormEnabled;

  const partnerEmail = partnerProfile?.professionalInformation?.email;

  const clientEmail = userDetails?.email;
  const isClientLoggedIn = Boolean(clientEmail);

  const handleLoggedOutUser = useCallback(() => {
    if (!isClientLoggedIn) {
      redirectUserToLogin(language);
    }
  }, [userDetails, language]);

  return {
    shouldUseAgencyContactForm,
    isAgencyContactFormEnabled,
    isMyProfile,
    havePageType,
    shouldRenderContactButtonWithoutPageType,
    shouldUseMailToButton,
    partnerEmail,
    handleLoggedOutUser,
    isClientLoggedIn,
  };
};

export default useProfileContactButton;

const redirectUserToLogin = (language: string) => {
  const currentHref = window.location.href;
  const currentUrl = new URL(currentHref);

  const urlWithBriefHash = new URL(currentHref);
  urlWithBriefHash.hash = '#brief';

  window.history.replaceState(history.state, '', currentUrl);
  window.location.assign(
    `${getWixLoginUrl(language)}&redirectTo=${encodeURIComponent(
      `${urlWithBriefHash}`,
    )}&originUrl=${encodeURIComponent(`${currentUrl} `)}`,
  );
};
